import { createAsyncActionType } from './index';

export const NEWSLETTER_GET = createAsyncActionType(
  'newsletter',
  'NEWSLETTER_GET'
);
export const NEWSLETTER_READ = createAsyncActionType(
  'newsletter',
  'NEWSLETTER_READ'
);
export const NEWSLETTER_DELETE = createAsyncActionType(
  'newsletter',
  'NEWSLETTER_DELETE'
);
export const NEWSLETTER_DETAILS_GET = createAsyncActionType(
  'newsletter',
  'NEWSLETTER_DETAILS_GET'
);

export const NEWSLETTER_DETAILS_RESET = '@@newsletter/NEWSLETTER_DETAILS_RESET';

export const NEWSLETTER_SEND = createAsyncActionType(
  'newsletter',
  'NEWSLETTER_SEND'
);

export const NEWSLETTER_BASE_TEMPLATE_GET = createAsyncActionType(
  'newsletter',
  'NEWSLETTER_BASE_TEMPLATE_GET'
);
